import React from 'react';
import { translate } from '../../utils/translations';
import PropTypes from 'prop-types';
import {
    logoPNG,
    meteocat,
    logo_generalitat,
    facebook_icon,
    twitter_icon,
    youtube_icon,
    instagram_icon,
    linkedin_icon,
} from '../../img';
import { links as urls } from '../../utils/urls';

const links = {
    facebook: 'https://www.facebook.com/meteocat',
    twitter: 'https://twitter.com/meteocat',
    youtube: 'https://www.youtube.com/meteocattv',
    instagram: 'https://www.instagram.com/meteocat_cat/',
    linkedin:
        'https://www.linkedin.com/company/servei-meteorol-gic-de-catalunya/',
};

const Header = props => (
    <div className="configurador__header">
        <div className="configurador__header-top">
            <img
                className="logo-generalitat"
                src={logo_generalitat}
                alt="Generalitat de Catalunya"
            />
            <ul className="configurador__header-top-languages">
                {props.renderLanguageMenuItem('ca', 'Català')}
                {props.renderLanguageMenuItem('es', 'Castellano')}
                {props.renderLanguageMenuItem('en', 'English')}
            </ul>
        </div>
        <div className="configurador__header-bottom">
            <div className="configurador__header-bottom-logos">
                <a href={urls.baseMeteo}>
                    <img className="logo" src={logoPNG} alt="logo Meteocat" />
                </a>
                <a className="meteocat" href={urls.baseMeteo}>
                    <img src={meteocat} alt="logo Meteocat" />
                </a>
            </div>
            <div className="title-wrapper">
                <h1>{translate(props.language, 'config_title')}</h1>
            </div>
            <div className="configurador__header-bottom-sm">
                <a href={links.facebook}>
                    <img src={facebook_icon} alt="facebook" />
                </a>
                <a href={links.twitter}>
                    <img src={twitter_icon} alt="twitter" />
                </a>
                <a href={links.youtube}>
                    <img src={youtube_icon} alt="youtube" />
                </a>
                <a href={links.instagram}>
                    <img src={instagram_icon} alt="instagram" />
                </a>
                <a href={links.linkedin}>
                    <img src={linkedin_icon} alt="linkedin" />
                </a>
            </div>
        </div>
    </div>
);

Header.propTypes = {
    language: PropTypes.string,
    renderLanguageMenuItem: PropTypes.func,
};

export default Header;



// WEBPACK FOOTER //
// ./src/containers/Configurador/Header.js